import { DataBean } from "../DataBean";


export class LoginServices extends DataBean {

    public async sendOTPAccountByNit(nit: number): Promise<any> {
        return this.getCustomService("MessageERP", "com.advantage.message.bean.Message_sendOTPAccountByNit_Number", [nit]);
    }

    public async validateWorkSesionSupplier(nit: string, otp: string, authType: string, ldap: string | null): Promise<any> {
        return this.getCustomService("MessageERP", "com.advantage.bean.account.WorkSession_validateWorkSesionSupplier_String_String_String_String", [nit, otp, authType, ldap]);
    }

    public async validateWorkSession(username: string, password: string, authType: string, ldap: string | null, ipAddress: string | null, macAddress: string | null): Promise<any> {
        return this.getCustomService("OrangeBase", "com.advantage.bean.account.WorkSession_validateWorkSession_String_String_String_String_String_String",
            [username, password, authType, ldap, ipAddress, macAddress]);
    }

    //Portal

    public async registerAffiliate(JsonAffiliate: string): Promise<any> {
        return this.getCustomService("CreditCore", "com.credit.bean.CreditAffiliate_registerAffiliate_String", [JsonAffiliate]);
    }

    public async validateCreditAffiliate(data: string): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.Map_validateCreditAffiliate_String", [data]);
    }
    public async getSessionsReport(page:number,rows:number,data: any): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.Report_getSessionsReport_Number_Number_java.util.Map", [page,rows,data]);
    }

}